/**
 * @param {object | null | undefined} gameState
 * @param {string | number | null | undefined} userId
 * @returns {boolean}
 */
export function didHumanPlayerWinGame(gameState, userId) {
  if (gameState?.winner == null || gameState.winner === undefined) {
    return false;
  }
  const winner = String(gameState.winner);
  const uid = String(userId);
  if (winner === uid) {
    return true;
  }
  if (Array.isArray(gameState.players)) {
    return gameState.players.some((p) => String(p) === winner && String(p) === uid);
  }
  return false;
}
